import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "text", "readMore" ]

  connect() {
    this.textTarget.dataset.originalContent = this.textTarget.innerHTML;
    this.updateText();
  }

  updateText() {
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.textTarget.dataset.originalContent, 'text/html');
    const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    let count = 0;
    let exceeded = false;
    while ((node = walker.nextNode())) {
      if (!exceeded) {
        count += node.textContent.length;
        if (count > 100) { // Adjust this value as needed
          node.textContent = node.textContent.substring(0, node.textContent.length - (count - 100)) + '...'; // Adjust this value as needed
          exceeded = true;
        }
      } else {
        node.textContent = '';
      }
    }
    this.textTarget.innerHTML = doc.body.innerHTML;
    this.readMoreTarget.style.display = exceeded ? 'inline' : 'none';
  }

  readMore(event) {
    event.preventDefault();
    this.textTarget.innerHTML = this.textTarget.dataset.originalContent;
    this.readMoreTarget.style.display = 'none';
  }
}
